import React, { FC, useContext, useCallback } from 'react'
import { connect } from 'react-redux'
import moment from 'moment';
import { Divider, List } from 'semantic-ui-react';

import GlobalContext from '../../../contexts/GlobalContext';
import Utility from '../../../Utility';
import MomentCustomer from '../../MomentCustomer/MomentCustomer';
import AmountProvider from '../../Provider/AmountProvider';
import BookingSupplementList from '../BookingsSupplements/BookingSupplementList';
import { bookingAddedSupplementsPerDate } from '../../../store/supplement'
import { RootState } from '../../../store';

const mapProps = (state: RootState) => ({
  options: state.supplement.options,
  extras: state.supplement.extras,
  bookings: state.booking.bookings,
  selectedBooking: state.booking.selectedBooking,
  bookingAddedSupplementsPerDate: bookingAddedSupplementsPerDate(state) 
})

type Props = {} & ReturnType<typeof mapProps>

const BookingAllDetails: FC<Props> = ({
  bookings, options, extras, bookingAddedSupplementsPerDate, selectedBooking
}) => {
  const [globalContext] = useContext(GlobalContext) as any

  /*const getSupplements = useCallback((data) => {
    let displayTab = [];
    let suppTab = [];
    let dateTab = [];

    if (data.bookingOptions && data.bookingOptions.length > 0) {
      data.bookingOptions.forEach(option => {
        const optionData = options.filter(opt => opt.id === option.optionId);
        const find = dateTab.find(date => {
          return date === option.date
        })
        if (find === undefined) dateTab.push(option.date);
        suppTab.push({
          id: option.id,
          date: option.date,
          optionId: option.optionId,
          name: optionData[0].name,
          totalAmount: option.totalAmount,
          currency: option.currency,
          isInclude: option.isInclude
        });
      })
    }

    if (data.bookingExtras && data.bookingExtras.length > 0) {
      data.bookingExtras.forEach(extra => {
        
        if( moment(extra.date).isBefore(data.arrivalDate) || moment(data.departureDate).isBefore(extra.date) ){
          extra.date = data.arrivalDate;
        }
        const extraData = extras.filter(ext => ext.id === extra.extraId);
        const find = dateTab.find(date => {
          return date === extra.date
        })
        if (find === undefined) dateTab.push(extra.date);
        if(extraData.length > 0) {
          suppTab.push({
            id: extra.id,
            date: extra.date,
            name: extraData[0].name,
            totalAmount: extra.totalAmount,
            currency: extra.currency
          })
        }
      })
    }

    if (dateTab.length > 0) {
      dateTab.sort();
      dateTab.forEach(date => {
        const value = suppTab.filter(supp => supp.date === date);
        displayTab.push({
          date: date,
          value: value
        });
      });
    }

    return displayTab;
  }, [booking])

  const supplements = getSupplements(booking)*/

  return (
    <>
      <div style={{maxHeight: 600, overflow: 'auto'}}>
        {/**<Grid columns="equal">
          <Grid.Row>
            <Grid.Column textAlign="center">
              <p>{globalContext.translations.filterBySupplements}</p>
              <Select onChange={(ev, el) => setSupplementsFilterState({ filter: el.value, booking: booking })} placeholder="..." options={[{ key: 1, value: '', text: '...' }, ...supplementsFilter]} />
            </Grid.Column>
            <Grid.Column textAlign="center">
              <p>{globalContext.translations.filterByDate}</p>
              <Select onChange={(ev, el) => setSupplementsDateFilterState({ filter: el.value, booking: booking })} placeholder="..." options={[{ key: 1, value: '', text: '...' }, ...dateFilter]} />
            </Grid.Column>
          </Grid.Row>
        </Grid>*/}
        {bookings[selectedBooking.index].bookingAccommodation.map((accommodation, index) => {
          return (
            <div key={accommodation.id} className="mt-4">
              <div>
                <h4 className="text-primary">
                  <MomentCustomer>{accommodation.date}</MomentCustomer>
                </h4>
              </div>
              <div className="p-3 d-flex justify-content-between">
                <div>
                  <h4>
                    {Utility.upperCase(
                      globalContext.translations.accommodation
                    )}
                  </h4>
                </div>
                <div>
                  <h4>
                    <AmountProvider
                      amount={accommodation.totalAmount}
                      currency={accommodation.currency}
                    />
                  </h4>
                </div>
              </div>
              <div className="pl-3 pr-3 pt-1 pb-3">
                <h4>
                  {Utility.upperCase(
                    globalContext.translations.supplementsEspaceClient
                  )}
                </h4>
                <List key={accommodation.id} className="pl-3">
                  {bookingAddedSupplementsPerDate?.[selectedBooking.id]?.[accommodation.date]
                    ?.map((suppl) => (
                      <BookingSupplementList
                        key={suppl.id}
                        options={options}
                        extras={extras}
                        supplValue={suppl}
                      />
                  ))}
                </List>
              </div>
              {index <
                bookings[selectedBooking.index].bookingAccommodation.length -
                  1 && <Divider />}
            </div>
          );
        })
        }
      </div>
    </>
  )
}

export default connect(mapProps)(BookingAllDetails)